import { createEntityAdapter } from '@reduxjs/toolkit';

import type { CartEcouponState } from '../slices/cart/cartECouponSlice';

export const cartECouponAdapter = createEntityAdapter<CartEcouponState, string>({
    selectId: (ecoupon) => ecoupon.couponId,
});
